// comps/WellDetailsSidebar.jsx

import React, { memo } from 'react';
import { useWellSelectionStore } from '@cores/stores/useWellSelectionStore';

// Correct: Direct registration for the web component
import "@arcgis/map-components/components/arcgis-features";

// Removed the old React wrapper import for ArcgisFeatures

import WellApiDetail from '@apps/components/DataViewer/WellDataViewer/WellApiDetail';
import { useAuthBiogems } from '@cores/security/hooks/useAuthBiogems';
import { NoDataNotice, LoginNotice } from '@libs/components/common/Notices';

/**
 * WellDetailsSidebar - Orchestrates what the user sees in the start/left panel.
 * Reads selection state directly from useWellSelectionStore to avoid prop drilling.
 */
const WellDetailsSidebar = ({ 
  featuresOpen, 
  featuresRef, 
  mapView
}) => {
  // ── Store Access ────────────────────────────────────────────────────────
  const checkedRds = useWellSelectionStore((s) => s.checkedRds);
  const selectedApiInfo = useWellSelectionStore((s) => s.selectedApiInfo);

  const { user } = useAuthBiogems();
  const isAuthenticated = !!user;

  if (!isAuthenticated) {
    return <LoginNotice />;
  }

  // 1. Show ArcGIS Popup/Features list (Map Click results)
  if (featuresOpen) {
    return (
      // Converted to the native web component tag
      <arcgis-features
        ref={featuresRef}
        view={mapView}
        // Ensure this ID matches your main container for proper positioning
        referenceElement="#IdMapViewerReservationWithDetailsPanel"
      />
    );
  }

  // 2. Show specific Well Details (from Store)
  if (selectedApiInfo?.id) {
    return (
      <WellApiDetail
        checkedRds={checkedRds}
        selectedApiInfo={selectedApiInfo}
      />
    );
  }

  // 3. Fallback: Default Welcome/Instruction state
  return (
    <NoDataNotice
      icon="information"
      title="Nothing Selected"
      message="Popup content or well details will appear here after you click a well point on the map or double‑click a row in the Well Table."
    />
  );
};

// Memoized to prevent sidebar flickering during map movements
export default memo(WellDetailsSidebar);
